export const cloudRouteEntries = {
  cloudAccountsList: () => import('./presentation/CloudAccountsListPage'),
  cloudAccountForm: () => import('./presentation/CloudAccountFormPage'),
  cloudAccountDetail: () => import('./presentation/CloudAccountDetailPage'),
  cloudVolumesList: () => import('./presentation/CloudVolumesListPage'),
  cloudVolumeForm: () => import('./presentation/CloudVolumeFormPage'),
  cloudVolumeDetail: () => import('./presentation/CloudVolumeDetailPage'),
  cloudVmForm: () => import('./presentation/CloudVmFormPage'),
  cloudVmDetail: () => import('./presentation/CloudVmDetailPage'),
  cloudServicesList: () => import('./presentation/CloudServicesListPage'),
  cloudServiceForm: () => import('./presentation/CloudServiceFormPage'),
  cloudServiceDetail: () => import('./presentation/CloudServiceDetailPage'),
} as const;